import { render, staticRenderFns } from "./pres_Report_F.vue?vue&type=template&id=20a393de"
import script from "./pres_Report_F.vue?vue&type=script&lang=js"
export * from "./pres_Report_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports